import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { communityComments } from '@/mocks/home';

export default function CommunityBuzz() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (index: number) => {
    setLiked((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <section id="community" className="bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <span className="inline-flex items-center gap-2 text-accent-700 text-xs md:text-sm font-bold tracking-wide">
                <i className="ri-chat-smile-3-line"></i>
                社区氛围
              </span>
              <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950 tracking-tight">
                大家正在聊什么
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
                不是只有小编在更新，讨论区里的每一条补充、每一个观点，都会让今天的话题变得更完整。
              </p>
            </div>
            <span className="shrink-0 inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-accent-100 text-accent-800 text-xs md:text-sm font-medium whitespace-nowrap">
              <span className="relative flex w-2 h-2 items-center justify-center">
                <span className="absolute inline-flex w-full h-full rounded-full bg-accent-500 animate-ping-soft"></span>
                <span className="relative inline-flex w-2 h-2 rounded-full bg-accent-500"></span>
              </span>
              876 人在线讨论中
            </span>
          </div>
        </Reveal>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-5">
          {communityComments.map((comment, index) => (
            <Reveal key={comment.name} delay={index * 80}>
              <article className="h-full bg-background-100 border border-background-200 rounded-lg p-5 hover:border-accent-300 transition-colors">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                    <i className="ri-user-smile-line text-xl"></i>
                  </span>
                  <span className="flex flex-col leading-tight min-w-0">
                    <span className="flex items-center gap-2">
                      <span className="text-sm font-bold text-foreground-950 truncate">{comment.name}</span>
                      <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-[11px] font-medium">
                        {comment.badge}
                      </span>
                    </span>
                    <span className="text-xs text-foreground-500 mt-0.5">{comment.time}</span>
                  </span>
                </div>
                <p className="mt-3.5 text-sm md:text-base text-foreground-700 leading-relaxed">
                  {comment.text}
                </p>
                <div className="mt-4 flex items-center gap-3">
                  <button
                    type="button"
                    onClick={() => toggleLike(index)}
                    className={`cursor-pointer inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap ${
                      liked[index]
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-50 border border-background-200 text-foreground-600 hover:text-primary-600 hover:border-primary-300'
                    }`}
                  >
                    <i className={liked[index] ? 'ri-heart-fill' : 'ri-heart-line'}></i>
                    {comment.likes + (liked[index] ? 1 : 0)}
                  </button>
                  <button
                    type="button"
                    className="cursor-pointer inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-foreground-600 text-xs font-medium hover:text-secondary-700 hover:border-secondary-300 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-reply-line"></i>
                    回复
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}